import React from 'react';
import { SORT_ORDER } from '/src/pages/directories/constants/sortConstants';

// Shared column-header sort/arrow logic. getSortList must be a lazy getter, not an array -
// class components build this before this.props exists - and drives both the default sort direction and the Export dialog's preset name.
export const createColumnSortHandlers = (getCurrentOrder, changeOrder, options = {}) => {
    const { isEnabled = () => true, getSortList = () => undefined } = options;

    const findPreset = (field, order) =>
        (getSortList() || []).find(item => item.field === field && (order === undefined || item.order === order));

    const handleColumnSort = (field) => {
        const currentOrder = getCurrentOrder() || {};
        const newOrder = currentOrder.field === field
            ? (currentOrder.order === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC)
            : (findPreset(field) || {}).order || SORT_ORDER.ASC;
        const preset = findPreset(field, newOrder);
        changeOrder(preset ? { field, order: newOrder, name: preset.name } : { field, order: newOrder });
    };

    const renderSortHeader = (label, sortKey) => {
        if (!isEnabled() || !sortKey) return label;
        const currentOrder = getCurrentOrder() || {};
        const isActive = currentOrder.field === sortKey;
        const icon = isActive ? (currentOrder.order === SORT_ORDER.ASC ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort';
        return (
            <span className={`dir-sortable-header${isActive ? ' active' : ''}`} onClick={() => handleColumnSort(sortKey)}>
                {label} <i className={`fa ${icon}${isActive ? ' active' : ''}`} />
            </span>
        );
    };

    return { handleColumnSort, renderSortHeader };
};

// A column's sort key, using a per-consumer override (keyed by keyName) when one exists.
// Lets a shared table sort by a field its backend supports (e.g. stage name, not stage id).
export const resolveColumnSortKey = (field, sortKeyOverrides) =>
    (sortKeyOverrides && sortKeyOverrides[field.keyName]) || field.sortKey;

// For a view that doesn't track its own order yet: prefer the view's own order, then tempFilter.order
// only if it's actually one of this view's own sortable fields, else the default.
export const resolveViewOrder = (ownOrder, tempFilterOrder, validFields, defaultOrder) => {
    if (ownOrder) return ownOrder;
    if (tempFilterOrder?.field && validFields.includes(tempFilterOrder.field)) return tempFilterOrder;
    return defaultOrder;
};
